import { render } from "./Topic.vue?vue&type=template&id=4160cc74"
import script from "./Topic.vue?vue&type=script&lang=js"
export * from "./Topic.vue?vue&type=script&lang=js"

import "./Topic.vue?vue&type=style&index=0&id=4160cc74&lang=scss"

import exportComponent from "/Users/patrikhubner/Dropbox/htdocs/netartmarathon/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__